<template>
    <v-card :loading="loading" :flat="true" mx-2>
        <template slot="progress">
            <v-overlay absolute class="d-flex flex-column text-center">
                <div>
                    <v-progress-circular size="250" width="10" color="primary" indeterminate>
                        <span>In curs de incarcare...</span>
                    </v-progress-circular>
                </div>
            </v-overlay>
        </template>
        <v-container class="px-10" fluid v-if="!loading">
            <v-row>
                <v-col cols="4">
                    <v-card elevation="2">
                        <v-card-title>Detalii transportator</v-card-title>
                        <v-card-subtitle>
                            Se va completa cu datele furnizorului de servicii de transport.
                        </v-card-subtitle>
                        <v-card-text>
                            <supplier-modal
                                v-model="form.transport_supplier"
                                :initial-items="[form.transport_supplier]"
                                :field-errors="errorMessages('transport_supplier_id')"
                                return-object
                            />
                        </v-card-text>
                    </v-card>
                </v-col>
                <v-col cols="4">
                    <v-card elevation="2">
                        <v-card-title>Detalii furnizor</v-card-title>
                        <v-card-subtitle>
                            Se va completa cu datele furnizorului de la care se realizeaza achizitia.
                        </v-card-subtitle>
                        <v-card-text>
                            <supplier-modal
                                v-model="form.supplier"
                                :initial-items="[form.supplier]"
                                :field-errors="errorMessages('supplier_id')"
                                return-object
                            />
                        </v-card-text>
                    </v-card>
                </v-col>
                <v-col cols="4">
                    <v-card elevation="2">
                        <v-card-title>Detalii transport</v-card-title>
                        <v-card-text>
                            <v-container>
                                <v-row>
                                    <v-col cols="12">
                                        <v-text-field
                                            v-model="form.upload_address"
                                            v-validate="'required'"
                                            :error-messages="errorMessages('upload_address')"
                                            :class="{ 'error--text': hasErrors('upload_address') }"
                                            class="primary--text"
                                            name="upload_address"
                                            label="Adresa de incarcare"
                                            data-vv-as="Adresa de incarcare"
                                            data-vv-name="upload_address"
                                        />
                                        <v-datetime-picker
                                            v-model="uploadTime"
                                            v-validate="'required'"
                                            :error-messages="errorMessages('upload_time')"
                                            :class="{ 'error--text': hasErrors('upload_time') }"
                                            class="primary--text"
                                            name="upload_time"
                                            label="Data si ora incarcarii"
                                            data-vv-as="Data si ora incarcarii"
                                            data-vv-name="upload_time"
                                            :timePickerProps="{format: '24hr'}"
                                        ></v-datetime-picker>
                                        <v-text-field
                                            v-model="form.download_address"
                                            v-validate="'required'"
                                            :error-messages="errorMessages('download_address')"
                                            :class="{ 'error--text': hasErrors('download_address') }"
                                            class="primary--text"
                                            name="download_address"
                                            label="Adresa de descarcare"
                                            data-vv-as="Adresa de descarcare"
                                            data-vv-name="download_address"
                                        />
                                        <v-datetime-picker
                                            v-model="downloadTime"
                                            v-validate="'required'"
                                            :error-messages="errorMessages('download_time')"
                                            :class="{ 'error--text': hasErrors('download_time') }"
                                            class="primary--text"
                                            name="download_time"
                                            label="Data si ora descarcarii"
                                            data-vv-as="Data si ora descarcarii"
                                            data-vv-name="download_time"
                                            :timePickerProps="{format: '24hr'}"
                                        ></v-datetime-picker>
                                    </v-col>
                                    <v-col cols="4">
                                        <v-text-field
                                            v-model="form.amount"
                                            v-validate="'required'"
                                            :error-messages="errorMessages('amount')"
                                            :class="{ 'error--text': hasErrors('amount') }"
                                            class="primary--text"
                                            name="amount"
                                            label="Pret"
                                            data-vv-as="Pret"
                                            data-vv-name="amount"
                                            type="number"
                                        />
                                    </v-col>
                                    <v-col cols="4">
                                        <v-select
                                            :items="(new $db.Transport).currencies"
                                            item-value="id"
                                            item-text="text"
                                            v-model="form.currency"
                                            v-validate="'required'"
                                            :error-messages="errorMessages('currency')"
                                            :class="{ 'error--text': hasErrors('currency') }"
                                            class="primary--text"
                                            name="currency"
                                            label="Exprimat in"
                                            data-vv-as="Exprimat in"
                                            data-vv-name="currency"
                                        />
                                    </v-col>
                                    <v-col cols="4">
                                        <v-text-field
                                            v-model="form.payment_due"
                                            v-validate="'required|numeric'"
                                            :error-messages="errorMessages('payment_due')"
                                            :class="{ 'error--text': hasErrors('payment_due') }"
                                            class="primary--text"
                                            name="payment_due"
                                            label="Termen de plata (zile)"
                                            data-vv-as="Termen de plata (zile)"
                                            data-vv-name="payment_due"
                                            type="number"
                                        />
                                    </v-col>
                                    <v-col cols="12">
                                        <v-textarea
                                            v-model="form.packages"
                                            v-validate="'required'"
                                            :error-messages="errorMessages('packages')"
                                            :class="{ 'error--text': hasErrors('packages') }"
                                            class="primary--text"
                                            name="packages"
                                            label="Specificatii pachete"
                                            data-vv-as="Specificatii pachete"
                                            data-vv-name="packages"
                                        />
                                        <v-textarea
                                            v-model="form.remarks"
                                            :error-messages="errorMessages('remarks')"
                                            :class="{ 'error--text': hasErrors('remarks') }"
                                            class="primary--text"
                                            name="remarks"
                                            label="Observatii"
                                            data-vv-as="Observatii"
                                            data-vv-name="remarks"
                                        />
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-card-text>
                    </v-card>
                </v-col>
                <v-col cols="12">
                    <v-btn
                        :loading="form.busy"
                        :disabled="errors.any() || form.busy"
                        block
                        color="success"
                        @click="submit()"
                    >
                        Salveaza
                        <v-icon right>
                            save
                        </v-icon>
                    </v-btn>
                </v-col>
            </v-row>
        </v-container>
    </v-card>
</template>

<script>
    import SupplierModal from 'Components/modal/SupplierModal'
    import validationError from "Mixins/validation-error";
    import {Form} from "vform";

    export default {
        mixins: [validationError],
        components: {
            SupplierModal
        },
        props: {
            id: {
                type: [Number, String],
                required: false
            }
        },
        data: () => ({
            tab: 'general',
            loading: false,
            /* Always Declare Your Form Object */
            form: new Form({
                id: null,
                transport_supplier_id: null,
                supplier_id: null,
                document_no: null,
                upload_address: null,
                download_address: null,
                upload_time: window.moment().toISOString(),
                download_time: window.moment().toISOString(),
                amount: null,
                amount_with_vat: null,
                currency: null,
                packages: null,
                remarks: null,
                payment_due: null,
                data: {},
            }),
            uploadTimeMenu: false,
            downloadTimeMenu: false
        }),
        watch: {
            'form.supplier': {
                handler(val) {
                    if(val?.id) {
                        this.form.supplier_id = val.id
                    }
                },
                deep: true
            },
            'form.transport_supplier': {
                handler(val) {
                    if(val?.id) {
                        this.form.transport_supplier_id = val.id
                    }
                },
                deep: true
            }
        },
        computed: {
            uploadTime: {
                set(val) {
                    this.form.upload_time = this.$moment(val).format('YYYY-MM-DD HH:mm:00')
                },
                get() {
                    return new Date(this.form.upload_time)
                }
            },
            downloadTime: {
                set(val) {
                    this.form.download_time = this.$moment(val).format('YYYY-MM-DD HH:mm:00')
                },
                get() {
                    console.log(this.form.download_time, new Date(this.form.download_time))
                    return new Date(this.form.download_time)
                }
            }
        },
        async mounted() {
            if(this.id) {
                await this.loadResource()
            }
        },
        methods: {
            async loadResource() {
                let self = this;
                this.loading = true;

                let { data } = await this.$db.Transport.include('supplier', 'transport_supplier').find(this.id)
                self.form = new Form(data)
                this.loading = false
            },
            async submit() {
                let self = this;
                this.$validator.validateAll().then(result => {
                    if (result) {
                        // eslint-disable-next-line
                        self.createOrUpdate();
                    } else {
                        this.showError()
                    }
                });
            },
            async createOrUpdate() {
                let self = this;
                self.form.busy = true;

                var model = new this.$db.Transport(self.form);
                if (this.id) {
                    model.id = this.id
                }

                model.save()
                    .then(response => {
                        self.$validator.reset();
                        this.showSuccess();
                        if (this._.isNil(model.id) && response?.id) {
                            self.$nextTick(() => self.$router.push({
                                name: "transports-edit",
                                params: {id: response.id}
                            }));
                        }
                    })
                    .catch(errors => {
                        self.form.errors.set(this.form.extractErrors(errors.response))
                        this.showError()
                    }).finally(() => {
                        self.form.busy = false;
                    });
            }
        }
    };
</script>
